
import { supabase } from '@/lib/supabase/client';
import { Product } from '@/lib/supabase/products/types';
import { setOrganizationIdCache } from '@/lib/supabase/products/organization';

export const fetchProductByShop = async (
  productSlug: string,
  shopId: string,
  organizationId?: string | null,
  setOrganizationId?: (id: string | null) => void
): Promise<Product | null> => {
  try {
    console.log("Fetching product by shop:", { productSlug, shopId });
    
    // Extract UUID if present in the slug (format: name-id)
    const uuidRegex = /-([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;
    const match = productSlug.match(uuidRegex);
    
    if (match && match[1]) {
      console.log("UUID extracted from slug:", match[1]);
      const { data, error } = await supabase
        .from('products')
        .select('*')
        .eq('id', match[1])
        .eq('shop_id', shopId)
        .single();
      
      if (!error && data) {
        console.log("Product found by UUID and shop:", data.name);
        
        if (data.organization_id && setOrganizationId) {
          console.log("Setting organization ID from product:", data.organization_id);
          setOrganizationId(data.organization_id);
          setOrganizationIdCache(data.organization_id);
        }
        
        return data as Product;
      }
    }
    
    // Try finding by slug if no UUID match
    const normalizedSlug = productSlug.toLowerCase().trim();
    const { data, error } = await supabase
      .from('products')
      .select('*')
      .eq('shop_id', shopId)
      .order('created_at', { ascending: false });
    
    if (error) {
      console.error("Error fetching products by shop:", error);
      return null;
    }
    
    // Find product with matching slug
    const product = data.find(p => {
      // Create normalized slug from product name
      const productNameSlug = p.name
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');
      
      return productNameSlug.includes(normalizedSlug) || normalizedSlug.includes(productNameSlug);
    });
    
    if (product) {
      console.log("Product found by name slug:", product.name);
      
      if (product.organization_id && setOrganizationId) {
        console.log("Setting organization ID from product:", product.organization_id);
        setOrganizationId(product.organization_id);
        setOrganizationIdCache(product.organization_id);
      }
      
      return product as Product;
    }
    
    return null;
  } catch (error) {
    console.error("Exception fetching product by shop:", error);
    return null;
  }
};
